import React from "react";
import BtnEstimate from "./BtnEstimate";
import { HashLink as Link } from "react-router-hash-link";

const Navbar = () => {
  return (
    <nav
      className="navbar navbar-expand-lg mt-5 sticky-top"
      style={{
        backgroundColor: "#C0C4C8",
        width: "850px",
        margin: "10px auto",
        borderRadius: "33px",
        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.2)", // Ajout de l'ombre
        maxWidth: "100%", // Pour s'assurer que le contenu ne dépasse pas la largeur de l'écran sur les petits appareils
        padding: "10px", // Ajouter un peu de rembourrage pour la lisibilité
        boxSizing: "border-box", // S'assurer que la largeur et la hauteur incluent les padding et border
        "@media (maxWidth: 768px)": {
          // Utilisation de CSS média requêtes pour les petits appareils
          width: "calc(100% - 20px)", // Calculer la largeur à 100% moins les marges pour s'adapter à l'écran
          margin: "10px", // Réduire la marge pour l'ajustement sur les petits écrans
          boxShadow: "none", // Supprimer l'ombre sur les petits écrans
        },
      }}
    >
      <div className="container-fluid">
        <Link
          className="navbar-brand"
          to="#"
          style={{ fontWeight: "800", fontSize: "20px" }}
        >
          BATIMENT
          <span
            style={{ fontStyle: "italic", color: "#0A6847", fontSize: "25px" }}
          >
            {" "}
            RS
          </span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto d-flex align-items-center">
            <li className="nav-item">
              <Link
                className="nav-link"
                to="#about"
                style={{
                  color: "#373F51",
                  fontWeight: "780",
                  fontSize: "18px",
                }}
              >
                À Propos
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="#Services"
                style={{
                  color: "#373F51",
                  fontWeight: "780",
                  fontSize: "18px",
                }}
              >
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="#Images"
                style={{
                  color: "#373f51",
                  fontWeight: "780",
                  fontSize: "18px",
                }}
              >
                Images
              </Link>
            </li>
            <li className="nav-item ms-3">
              <Link className="nav-link" to="#Contact">
                <BtnEstimate />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
